import styled from "styled-components";

export const ButtonGroup = styled.div<{center: boolean}>`
    display: flex;
    justify-content: ${(props) => (props.center ? "center" : "space-between")};
    margin-top: 40px;
`;
